<template>
    <div class="inform col-12">
        <div class="form-row">
            <div class="col-md-12">
                <label>Клиент</label>
                <select @change="onChangeClient($event)" class="form-select" v-model="forms.clients.selected">
                    <option v-for="item in forms.clients.items" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label>Брэнд</label>
                <select :disabled="!forms.clients.selected" @change="onChangeBrand($event)" class="form-select" v-model="forms.brands.selected">
                    <option v-for="item in forms.brands.items" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label>Организация</label>
                <select :disabled="!forms.clients.selected" @change="onChangeOrg($event)" class="form-select" v-model="forms.orgs.selected">
                    <option v-for="item in forms.orgs.items" :value="item.id">{{ item.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-row">
            <div class="col-md-12">
                <label>Период</label>
                <div class="mt-3 d-flex align-items-center justifully-content-center">
                    <span class="me-2">с</span>
                    <input
                        type="date"
                        class="form-control w-25"
                        id="created-license"
                        v-model="forms.period.from"
                        @change="setDateTo($event)"
                    >
                    <span class="ms-2 me-2">по</span>
                    <input
                        type="date"
                        class="form-control w-25"
                        id="expires-at"
                        v-model="forms.period.to"
                    >
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex w-50 align-items-center justify-content-start">
        <button class="btn btn-lg btn-primary me-3" v-on:click="onCreate()">
            Сформировать документы
        </button>
        <a class="btn btn-lg btn-outline-dark" href="/documents/licenses">Отменить</a>
    </div>
    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
  name: "AccountCreateComponent",
  components: { Alert },
  props: {
    list_accounting_documents: String
  },
  watch: {
  },
  data: function () {
    return {
        forms: {
            clients: {
                selected: null,
                items: []
            },
            brands: {
                selected: null,
                items: [],
            },
            orgs: {
                selected: null,
                items: []
            },
            period: {
                from: null,
                to: null
            }
        },
    }
  },
  methods: {
    ...mapMutations('alerts', ['addAlert']),
    setDateTo: async function(e) {
      const selectedDateFrom = new Date(e.target.value);
      selectedDateFrom.setDate(selectedDateFrom.getDate() + 1);
      const $date = selectedDateFrom.toISOString().slice(0, 10);
      document.getElementById("expires-at").setAttribute('min', $date);
      document.getElementById("expires-at").value = '';
    },
    onChangeClient: async function (e) {
        const selectedClient = e.target.value;

        const dataBrands = await axios.get('/organizational/brands/list', {params: {
            client_id: selectedClient,
            limit: 500,
            page: 1
        }}).then(resp => {
            return resp.data
        });

        if (dataBrands.status == 'ok') {
            this.forms.brands.items = dataBrands.items;
        }

        if (dataBrands.status != 'ok') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список брэндов' });
        }

        const dataOrgs = await axios.get('/organizational/organizations/list', {params: {
            client_id: selectedClient,
            limit: 500,
            page: 1
        }}).then(resp => {
            return resp.data
        });

        if (dataOrgs.status == 'ok') {
            this.forms.orgs.items = dataOrgs.items;
        }

        if (dataOrgs.status != 'ok') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список брэндов' });
        }
    },
    onChangeBrand: function (e) {

    },
    onChangeOrg: function (e) {

    },
    getClients: async function () {
        const data = await axios.get('/organizational/client/list', {params: {
            limit: 500,
            page: 1
        }}).then(resp => {
            return resp.data
        });

        if (data.status == 'ok') {
            this.forms.clients.items = data.items;
        }

        if (data.status != 'ok') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список клиентов' });
        }
    },
    onCreate: async function() {
        const data = await axios.post('/documents/licenses/create-account', {
            org_id: this.forms.orgs.selected,
            from: this.forms.period.from,
            to: this.forms.period.to,
            client_id: this.forms.clients.selected
        }).then(resp => {
          if (resp.data.status == 'ok') {
            if (window.confirm('Документы успешно сформированы.\nФайлы доступны в разделе Отчетные документы.\nПерейти в раздел?')) {
              window.location.href = this.list_accounting_documents;
            }
          }

          if (resp.data.status && resp.data.status == 'error') {
            this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
          }
        }).catch(_ => {
            this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось сформировать документы, что то пошло не так' });
        });
    },
  },
    async mounted() {
    await this.getClients();
  }
}
</script>

<style scoped>
  .app-dropdown {
      border-radius: 5px;
      position: relative;
  }

  .app-dropdown .manager {
      border: 1px solid #ddd;
      border-radius: 4px;
  }

  .app-dropdown .items-block {
      position: relative;
      height: 200px;
      overflow: auto;
      z-index: 9999;
      background-color: #fff;
      border-bottom: 1px solid #ddd;
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
  }

  .app-dropdown .items-block .searching-block {
      position: sticky;
      top: 0;
      background-color: #fff;
  }

  .app-dropdown .items-block .searching-block input {
      border-bottom: 1px solid #ddd;
      border-top: none;
      border-radius: 0;
      border-left: none;
      border-right: none;
  }

  .app-dropdown .items {
      position: absolute;
      width: 100%;
  }

  .app-dropdown .items .item {
      padding: 0 10px;
      cursor: pointer;
      font-size: 16px;
  }

  .app-dropdown .items .item:hover {
      background-color: #3c7af0;
      color: white;
  }

  .app-dropdown .hidden {
      display: none;
  }

  .app-dropdown .manager {
      padding: 15px;
      height: 40px;
      cursor: pointer;
  }

  .app-dropdown .manager .button {
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
      background-repeat: no-repeat;
      background-position: center right;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: 16px;
  }

  .app-dropdown .shade {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 999;
      min-height: 100vh;
      overflow: hidden;
  }

  .app-dropdown .content {
      position: absolute;
      width: 100%;
      height: 200px;
  }

  .app-dropdown .disable {
      background-color: #ddd;
      cursor: initial;
  }
</style>
